import { render, staticRenderFns } from "./ImageCodeAttachmentComponent.vue?vue&type=template&id=0af75de0&"
import script from "./ImageCodeAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./ImageCodeAttachmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports